export default defineNuxtRouteMiddleware(() => {
  useNuxtApp().hook('page:finish', () => {
    scrollToTop(0, false);
  });
});
